import PropTypes from "prop-types";
import Lomake from "@/components/02-organisms/Lomake";
import {
  useChangeObjects,
  useChangeObjectsByAnchorWithoutUnderRemoval
} from "@/stores/muutokset";
import { useCallback } from "react";
import { map } from "ramda";
import { useIntl } from "react-intl";
import common from "@/i18n/definitions/common.js";

const constants = {
  formLocation: ["tutkinnot"]
};

const Koulutusala = ({
  data,
  isPreviewModeOn,
  isReadOnly,
  mode,
  sectionId,
  title,
  tutkinnot
}) => {
  const intl = useIntl();
  const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
    anchor: sectionId
  });
  const [, { addChangeObjectWithAnchor, setChanges }] = useChangeObjects();

  const onAddButtonClick = useCallback(
    (fromComponent, tutkinto, koulutustyyppi) => {
      addChangeObjectWithAnchor(
        sectionId,
        `${koulutustyyppi.koodiarvo}.${tutkinto.koodiarvo}.voimassaoloaika`
      );
    },
    [addChangeObjectWithAnchor, sectionId]
  );
  const onRemoveButtonClick = useCallback(
    (fromComponent, tutkinto, koulutustyyppi) => {
      addChangeObjectWithAnchor(
        sectionId,
        `${koulutustyyppi.koodiarvo}.${tutkinto.koodiarvo}.voimassaoloaika`,
        { removed: true }
      );
    },
    [addChangeObjectWithAnchor, sectionId]
  );
  const onChanges = useCallback(
    (changes, anchor, targetNode) => {
      setChanges(changes, anchor, targetNode.original.fullAnchor);
    },
    [sectionId, setChanges]
  );

  const onSelectAll = () => {
    return map(tutkinto => {
      const relevantPart = tutkinto.koulutustyyppikoodiarvo;
      const koodiarvo = tutkinto.koodiarvo;
      // tutkinnot_02.1.321141.tutkinto
      // Create the new object structure
      return {
        anchor: `${sectionId}.${relevantPart}.${koodiarvo}.tutkinto`,
        properties: {
          isChecked: true
        }
      };
    }, tutkinnot);
  };

  const onDeselectAll = () => {
    return map(tutkinto => {
      const relevantPart = tutkinto.koulutustyyppikoodiarvo;
      const koodiarvo = tutkinto.koodiarvo;
      // tutkinnot_02.1.321141.tutkinto
      // Create the new object structure
      return {
        anchor: `${sectionId}.${relevantPart}.${koodiarvo}.tutkinto`,
        properties: {
          isChecked: false
        }
      };
    }, tutkinnot);
  };

  return (
    <Lomake
      anchor={sectionId}
      runInsteadOfSettingChanges={onChanges}
      changeObjects={changeObjects}
      data={data}
      functions={{
        onAddButtonClick,
        onRemoveButtonClick
      }}
      selectAll={true}
      onDeselectAll={onDeselectAll}
      onSelectAll={onSelectAll}
      selectAllText={intl.formatMessage(common.selectalltutkinnotbtn)}
      isPreviewModeOn={isPreviewModeOn}
      isReadOnly={isReadOnly}
      isRowExpanded={mode === "reasoning"}
      key={sectionId}
      mode={mode}
      path={constants.formLocation}
      rowTitle={title}
      showCategoryTitles={true}
    />
  );
};

Koulutusala.propTypes = {
  data: PropTypes.object,
  isPreviewModeOn: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  mode: PropTypes.string,
  sectionId: PropTypes.string,
  title: PropTypes.string,
  tutkinnot: PropTypes.array
};

export default Koulutusala;
